var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patches-template',{attrs:{"patches":_vm.patches,"patches-type":_vm.patchesType,"is-patches-type-visible":_vm.isPatchesTypeVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }